import React from "react"
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import { FormSectionElements, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { dateComparisonList, feedbackStatusOptions, odsCallOutBoxs } from "../../entities/Constants";
import { InputTextarea } from "primereact/inputtextarea";
import { Editor } from "primereact/editor";
import { Checkbox } from "primereact/checkbox";
import { getRootComponent } from "../../utilities/ElementUtils";


interface Props {
    ele: FormSectionElements;
    dialogVisible: boolean;
    isEng: boolean;
    callback;

}

export class DialogForFeedbackComponent extends React.Component<Props> {

    dateTypeFieldList = [];
    expectedValueOptions = []
    constructor(props: Props) {
        super(props);

        let subSection = this.props.ele.parent as FormSubSections;
        this.dateTypeFieldList = subSection.ListOfFormSectionElements?.filter(p => p.Datatype === 'Date' && p.Sequence < this.props.ele.Sequence);
        if (this.props.ele.Datatype === "RadioButton" && this.props.ele.ListOfLOVValues?.length) {
            this.expectedValueOptions = [{ label: 'Select a expected value', labelFRA: 'Sélectionnez une valeur attendue', val: '' }]
                .concat(
                    this.props.ele.ListOfLOVValues
                        .map(item => ({
                            label: item.description, labelFRA: item.FRADescription, val: item.code
                        }))
                );
        }
    }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog header={this.props.isEng ? "Field Properties for " + this.props.ele.ENUTitle : "Field Properties for " + this.props.ele.FRATitle}
                    footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }}
                    onHide={() => this.props.callback(false)}
                >
                    {this.otherPreviousDateFields()}
                </Dialog>
            </>
        );
        return html;
    }

    otherPreviousDateFields = () => {
        let htmlString = [];
        let programContainer = getRootComponent(this.props.ele);

        htmlString.push(
            <div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Script</div>
                    <div style={{ width: '60%' }}>
                        <InputTextarea className="ontario-input" key={"Script" + this.props.ele.Sequence}
                            value={this.props.ele.Script} onChange={(e) => {
                                this.props.ele.Script = e.target.value;
                                this.props.callback();
                            }}></InputTextarea></div>
                </div>
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '20px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"UpdateField" + this.props.ele.Sequence}>Update Binding Field</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"UpdateField" + this.props.ele.Sequence} value={this.props.ele.UpdateField} className="ontario-input"
                            onChange={(e) => { this.props.ele.UpdateField = e.target.value; this.props.callback() }}
                        />
                    </div>
                </div>

                <div style={{ display: ["Dropdown","CheckboxGroup","CheckGroup","RadioButton"].includes(this.props.ele.Datatype)? "flex":"none" , marginTop: '10px', marginBottom: '20px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"LovAPI" + this.props.ele.Sequence}>List of Values API</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"LovAPI" + this.props.ele.Sequence} value={this.props.ele.LovAPI} className="ontario-input"
                            onChange={(e) => { this.props.ele.LovAPI = e.target.value; this.props.callback() }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Question Hint</div>
                    <div style={{ width: '60%' }}>

                        {/* @ts-ignore */}
                        <Editor style={{ height: 'auto' }} key={"Hint" + this.props.ele.Sequence}
                            value={this.props.isEng ? this.props.ele.Hint : this.props.ele.HintFR} onTextChange={(e) => {
                                if (this.props.isEng)
                                    this.props.ele.Hint = e.htmlValue;
                                else
                                    this.props.ele.HintFR = e.htmlValue;

                                this.props.callback();
                            }}></Editor></div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Empty Error Message</div>
                    <div style={{ width: '60%' }}>
                        <InputText className="ontario-input" value={this.props.isEng ? this.props.ele.EmptyErrorMessage : this.props.ele.EmptyErrorMessageFRA}
                            onChange={(e) => {
                                if (this.props.isEng)
                                    this.props.ele.EmptyErrorMessage = e.target.value;
                                else
                                    this.props.ele.EmptyErrorMessageFRA = e.target.value;
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Custom Error Message</div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"ErrorMessage" + this.props.ele.Sequence}
                            className="ontario-input"
                            value={this.props.isEng ? this.props.ele.ErrorMessage : this.props.ele.ErrorMessageFRA}
                            onChange={(e) => {
                                if (this.props.isEng)
                                    this.props.ele.ErrorMessage = e.target.value;
                                else
                                    this.props.ele.ErrorMessageFRA = e.target.value;

                                this.props.callback();
                            }}
                        />
                    </div>
                </div>
                {this.props.ele.Datatype === "RadioButton" && this.props.ele.ListOfLOVValues?.length && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Expected values</div>
                        <div style={{ width: '60%' }}>
                            {/* @ts-ignore */}
                            <Dropdown key={"ExpectedOption" + this.props.ele.Sequence}
                                options={this.expectedValueOptions}
                                optionLabel={this.props.isEng ? 'label' : 'labelFRA'}
                                optionValue='val'
                                value={this.props.ele.ListOfExpectedValues?.[0] ?? ''}
                                onChange={(e) => {
                                    this.props.ele.ListOfExpectedValues = [e.target.value];
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                )}

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Tool Tip</div>
                    <div style={{ width: '60%' }}><InputText key={"TooltipENU" + this.props.ele.Sequence} className="ontario-input" value={this.props.isEng ? this.props.ele.TooltipENU : this.props.ele.TooltipFRA} onChange={(e) => {
                        if (this.props.isEng)
                            this.props.ele.TooltipENU = e.target.value;
                        else
                            this.props.ele.TooltipFRA = e.target.value;

                        this.props.callback();
                    }}></InputText></div>
                </div>

                {/* <div style={{ display: this.props.ele.Optional == 'N' ? "flex" : "none", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Customize Error Message</div>
                    <div style={{ width: '60%' }}><InputText className="ontario-input" value={this.props.ele.ErrorMessage}
                        onChange={(e) => {
                            if (this.props.isEng)
                                this.props.ele.ErrorMessage = e.target.value;
                            this.props.callback();
                        }}></InputText></div>
                </div> */}

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Hint Expansion Title</div>
                    <div style={{ width: '60%' }}><InputText key={"hintExpansionTitle" + this.props.ele.Sequence}
                        className="ontario-input" value={this.props.isEng ? this.props.ele.hintExpansionTitle : this.props.ele.hintExpansionTitleFRA}
                        onChange={(e) => {
                            if (this.props.isEng)
                                this.props.ele.hintExpansionTitle = e.target.value;
                            else {
                                this.props.ele.hintExpansionTitleFRA = e.target.value;
                            }
                            this.props.callback();
                        }}></InputText></div>
                </div>

                {/* Alert box options */}
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown key={"callOutBoxType" + this.props.ele.Sequence} showClear options={odsCallOutBoxs} optionLabel='label' optionValue='val' value={this.props.ele.callOutBoxType} onChange={(e) => {
                            if (this.props.isEng) {
                                this.props.ele.callOutBoxType = e.value;
                            } else {
                                this.props.ele.callOutBoxBodyFRA = e.value;
                            }
                            this.props.callback();
                        }}></Dropdown>
                    </div>
                </div>

                <div style={{ display: this.props.ele.callOutBoxType != null ? "flex" : "none", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box Title</div>
                    <div style={{ width: '60%' }}><InputText key={"callOutBoxTitle" + this.props.ele.Sequence} className="ontario-input"
                        value={this.props.isEng ? this.props.ele.callOutBoxTitle : this.props.ele.callOutBoxTitleFRA}
                        onChange={(e) => {
                            if (this.props.isEng)
                                this.props.ele.callOutBoxTitle = e.target.value;
                            else
                                this.props.ele.callOutBoxTitleFRA = e.target.value;
                            this.props.callback();
                        }}></InputText></div>
                </div>

                <div style={{ display: this.props.ele.callOutBoxType != null ? "flex" : "none", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box Body Message</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Editor className="ontario-input" value={this.props.isEng ? this.props.ele.callOutBoxBody : this.props.ele.callOutBoxBodyFRA}
                            onTextChange={(e) => {
                                if (this.props.isEng)
                                    this.props.ele.callOutBoxBody = e.htmlValue;
                                else
                                    this.props.ele.callOutBoxBodyFRA = e.htmlValue;
                                this.props.callback();
                            }}></Editor>
                    </div>
                </div>


                <div style={{ display: "flex", marginTop: '10px' }}>

                    <div style={{ width: '25%' }}>
                        <label htmlFor={"maskinsummary_" + this.props.ele.Sequence}>Mask in Summary</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.MaskInSummary} id={"maskinsummary_" + this.props.ele.Sequence}
                            onChange={(e) => { this.props.ele.MaskInSummary = e.checked; this.props.callback() }} checked={this.props.ele.MaskInSummary} />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Feedback URL</div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"feedback-url" + this.props.ele.Sequence} className="ontario-input"
                            value={this.props.isEng ? this.props.ele.FeedbackURL: this.props.ele.FeedbackURLFRA}
                            onChange={(e) => {
                                if (this.props.isEng) {
                                    this.props.ele.FeedbackURL = e.target.value;
                                } else {
                                    this.props.ele.FeedbackURLFRA = e.target.value;
                                }
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Feedback URL-CXP specific</div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"feedback-url-cxp" + this.props.ele.Sequence} className="ontario-input"
                            value={this.props.isEng ? this.props.ele.FeedbackURL_CXP: this.props.ele.FeedbackURLFRA_CXP}
                            onChange={(e) => {
                                if (this.props.isEng) {
                                    this.props.ele.FeedbackURL_CXP = e.target.value;
                                } else {
                                    this.props.ele.FeedbackURLFRA_CXP = e.target.value;
                                }
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Feedback status</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown key={"feedback-status" + this.props.ele.Sequence} 
                            showClear 
                            options={feedbackStatusOptions} 
                            optionLabel='label' 
                            optionValue='val' 
                            value={this.props.ele.feedback?.status} 
                            onChange={(e) => {
                                this.props.ele.feedback = {...this.props.ele.feedback ?? {}, status: e.value, };
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>code: </div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"feedback-code" + this.props.ele.Sequence} className="ontario-input"
                            value={this.props.ele.feedback?.code}
                            onChange={(e) => {
                                this.props.ele.feedback = {...this.props.ele.feedback ?? {}, code: e.target.value};
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>
            </div>
        )

        return htmlString;
    }

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
